import React from 'react';

interface ErrorMessageProps {
  message: string;
  // eslint-disable-next-line react/require-default-props
  className?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  className = '',
}) => {
  if (!message) return null;

  return (
    <div
      className={`mb-4 p-3 bg-red-50 border border-red-200 rounded-lg ${className}`}
    >
      <p className="text-sm text-red-600">{message}</p>
    </div>
  );
};

export default ErrorMessage;
